import { render, staticRenderFns } from "./TextTruncate.vue?vue&type=template&id=0c5cff4f&"
import script from "./TextTruncate.vue?vue&type=script&lang=ts&"
export * from "./TextTruncate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports